export default __webpack_public_path__ + "static/media/parachute-heavy-duty-box.f0c00f39.png";